(function () {
  function updateTrackOrderLinks() {
    document
      .querySelectorAll(
        'a[href="/pages/track-orders"], a[href$="/pages/track-orders"], a[href="/apps/aftership"], a[href$="/apps/aftership"]'
      )
      .forEach(function (link) {
        link.setAttribute('href', '/pages/tracking');
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateTrackOrderLinks);
  } else {
    updateTrackOrderLinks();
  }
})();
